import { render, staticRenderFns } from "./awardRecord.vue?vue&type=template&id=287553ae&scoped=true&"
import script from "./awardRecord.vue?vue&type=script&lang=js&"
export * from "./awardRecord.vue?vue&type=script&lang=js&"
import style0 from "./awardRecord.vue?vue&type=style&index=0&id=287553ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287553ae",
  null
  
)

export default component.exports